/**
 * StaffPortalPolicyService
 * Read-only service for staff policy + signature lookups.
 * Route: api/staff-portal/policies
 */
import { StaffPortalBaseService } from './StaffPortalBaseService';
export class StaffPortalPolicyService extends StaffPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? StaffPortalPolicyService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? StaffPortalPolicyService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * List currently-published policies.
     * GET /api/staff-portal/policies
     */
    async listPublished() {
        const response = await this.listPublishedRaw();
        return response.data ?? [];
    }
    listPublishedRaw() {
        return this.get();
    }
    /**
     * List policy categories.
     * GET /api/staff-portal/policies/categories
     */
    async listCategories() {
        const response = await this.listCategoriesRaw();
        return response.data ?? [];
    }
    listCategoriesRaw() {
        return this.get('categories');
    }
    /**
     * Get a specific policy. Staff can read a policy only if they have an
     * assignment for it OR the policy is currently published.
     * GET /api/staff-portal/policies/{id}
     */
    async getPolicy(id) {
        const response = await this.getPolicyRaw(id);
        if (!response.data) {
            throw new Error(`Policy ${id} not found`);
        }
        return response.data;
    }
    getPolicyRaw(id) {
        return this.get(String(id));
    }
    /**
     * Get the current staff member's policy-signature audit history.
     * GET /api/staff-portal/policies/signatures
     */
    async getMySignatures() {
        const response = await this.getMySignaturesRaw();
        return response.data ?? [];
    }
    getMySignaturesRaw() {
        return this.get('signatures');
    }
}
// Routes through the HRManagement API gateway — see StaffPortalDutyService.
StaffPortalPolicyService.DEFAULT_SERVICE_PATH = 'hr';
StaffPortalPolicyService.BASE_PATH = 'api/staff-portal/policies';
//# sourceMappingURL=StaffPortalPolicyService.js.map